const React = require('react')
const PropTypes = require('prop-types')
const withStyles = require('withStyles').default
const styles = require('./unsupported.less')

/* eslint-disable max-len */
const browser_message = (
    <div>
        <p>Your browser is not supported. Out of date browsers have security flaws and may not display all features of about.me.</p>
        <p>Please upgrade to a newer browser by <a href="http://browsehappy.com/" className="text underline">downloading one here</a>.</p>
    </div>
)
const iframe_message = (
    <div>
        <p>Hmmm… It looks like this page is not an official about.me page and may be unsafe.</p>
        <p>Please close this browser window and visit about.me in a new window.</p>
    </div>
)
/* eslint-enable max-len */

function isIframe() {
    // return true if window.self/top can't be compared
    // if that's the case, assume something fishy
    try {
        return window.self !== window.top
    } catch {
        return true
    }
}

class Unsupported extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            visible: true,
            className: 'unsupported',
            message: browser_message,
        }
    }

    componentDidMount() {
        this.checkForIframe()
    }

    checkForIframe() {
        if (isIframe()) {
            this.setState({
                className: 'unsupported iframe',
                message: iframe_message,
            })
        }
    }

    render() {
        const { UNSUPPORTED } = this.context.globals
        if (! UNSUPPORTED) return null

        const { visible, message } = this.state
        if (! visible) return null

        return (
            <div className={this.state.className}>
                <div
                    className="close glyph-close glyph-center"
                    onClick={(e) => this.setState({ visible: false })}
                    >
                    &nbsp;
                </div>
                {message}
            </div>
        )
    }
}

Unsupported.contextTypes = {
    globals: PropTypes.object.isRequired,
}

module.exports = withStyles(styles)(Unsupported)
